/**
 * recently-viewed.js
 *
 * Saves product handles on PDP visits, then fills <recently-viewed> by
 * re-requesting its section with those handles as the search query.
 */
const STORAGE_KEY = 'recently-viewed-products';
const STORAGE_MAX = 20;

function readHandles() {
  try {
    const raw = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    return Array.isArray(raw) ? raw.filter((h) => typeof h === 'string' && h) : [];
  } catch {
    return [];
  }
}

function saveHandle(handle) {
  if (!handle) return;
  const next = [handle, ...readHandles().filter((h) => h !== handle)].slice(0, STORAGE_MAX);
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    /* quota / private mode */
  }
}

const currentHandle = document.body?.dataset.productHandle;
if (currentHandle) saveHandle(currentHandle);

if (!customElements.get('recently-viewed')) {
  customElements.define(
    'recently-viewed',
    class RecentlyViewed extends HTMLElement {
      connectedCallback() {
        if (this._loaded) return;
        this._loaded = true;

        const section = this.closest('.shopify-section');
        const limit = parseInt(this.dataset.limit, 10) || 4;
        let handles = readHandles().filter((h) => h !== currentHandle).slice(0, limit);

        if (!handles.length) {
          if (!this.hidden) return;
          if (section) section.hidden = true;
          return;
        }

        const searchUrl = this.dataset.searchUrl || '/search';
        const url = `${searchUrl}?q=${encodeURIComponent(handles.join(' '))}&type=product&section_id=${this.dataset.sectionId}`;

        fetch(url)
          .then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
          .then((text) => {
            const fetched = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('recently-viewed');
            if (!fetched || !fetched.querySelector('.product-grid__item')) {
              if (section) section.hidden = true;
              return;
            }
            this.innerHTML = fetched.innerHTML;
            this.hidden = false;
            if (section) section.hidden = false;
            document.dispatchEvent(new CustomEvent('on:reveal:scan'));
          })
          .catch(() => {
            if (section) section.hidden = true;
          });
      }
    }
  );
}
